import { SET_SEGMENT_PICKER_SORTING } from './actionTypes';

const setSegmentPickerSorting = sortOption => ({
    type: SET_SEGMENT_PICKER_SORTING,
    payload: sortOption,
});

export default setSegmentPickerSorting;
